import { render, staticRenderFns } from "./DoctorsItemCircle.vue?vue&type=template&id=41849102&scoped=true"
import script from "./DoctorsItemCircle.vue?vue&type=script&lang=js"
export * from "./DoctorsItemCircle.vue?vue&type=script&lang=js"
import style0 from "./DoctorsItemCircle.vue?vue&type=style&index=0&id=41849102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41849102",
  null
  
)

export default component.exports